var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { grayBorder } from './CMSTouchPanel/colors';
export var WindowHeaderHeight = 15;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  height: ", "px;\n  grid-template-columns: 15px auto 15px;\n  font-size: 12px;\n  justify-content: space-between;\n  color: gray;\n  ", "\n"], ["\n  width: 100%;\n  display: flex;\n  height: ", "px;\n  grid-template-columns: 15px auto 15px;\n  font-size: 12px;\n  justify-content: space-between;\n  color: gray;\n  ", "\n"])), WindowHeaderHeight, grayBorder);
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 15px;\n  ", "\n"], ["\n  width: 15px;\n  ", "\n"])), grayBorder);
export default function WindowHeader(_a) {
    var name = _a.name;
    return (React.createElement(Container, null,
        React.createElement(IconContainer, null),
        React.createElement("div", null, name),
        React.createElement(IconContainer, null)));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=WindowHeader.js.map